import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { getUser } from 'src/utils/Common';

// Middleware Context
const MiddlewareContext = createContext();

export const MiddlewareProvider = ({ children }) => {
    const [trackedValues, setTrackedValues] = useState([]);

    const dispatch = useDispatch();

    const SessionUser = getUser();


    useEffect(() => {
        // tenantId kontrolü
        const trackValue = () => {
            const value = localStorage.getItem('baslandiFis');
            if (value) {
                const parsedValue = JSON.parse(value); // Parse the JSON string
                const receiptNo = parsedValue.ReceiptNo; // Access the ReceiptNo key
                const technicianCode = parsedValue.TechnicianCode; // Access the TechnicianCode key
                const appointmentDate = parsedValue.AppointmentDate;
                setTrackedValues(prev => [...prev, value]);
            }
        };

        window.addEventListener('localStorageChange', trackValue);

        return () => {
            window.removeEventListener('localStorageChange', trackValue);
        };
    }, []);


    return (
        <MiddlewareContext.Provider value={{ trackedValues }}>
            {children}
        </MiddlewareContext.Provider>
    );
};

export const useMiddleware = () => useContext(MiddlewareContext);